import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useParams} from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from './../../Auth/apiService.jsx';
import { useAuth } from './../../Auth/AuthContext.jsx';
import { jsPDF } from 'jspdf';
import GetPaginaUno from './PaginasDx/GetPaginaUno.jsx';
import GetPaginaDos from './PaginasDx/GetPaginaDos.jsx';
import GetPaginaTres from './PaginasDx/GetPaginaTres.jsx';
import GetPaginaCuatroM from './PaginasDx/GetPaginaCuatroM.jsx';
import GetPaginaCincoM from './PaginasDx/GetPaginaCincoM.jsx';
import GetPaginaSeisM from './PaginasDx/GetPaginaSeisM.jsx';
import GetPaginaSieteM from './PaginasDx/GetPaginaSieteM.jsx';
import GetPaginaOchoM from './PaginasDx/GetPaginaOchoM.jsx';
import GetPaginaNueveM from './PaginasDx/GetPaginaNueveM.jsx';
import GetPaginaSiete from './PaginasDx/GetPaginaSiete.jsx';
import GetPaginaDoceM from './PaginasDx/GetPaginaDoceM.jsx';
import GetPaginaTreceM from './PaginasDx/GetPaginaTreceM.jsx';
import GetPaginaCatorceM from './PaginasDx/GetPaginaCatorceM.jsx';
import GetPaginaQuinceM from './PaginasDx/GetPaginaQuinceM.jsx';
import GetPaginaDieciseisM from './PaginasDx/GetPaginaDieciseisM.jsx';
import GetPaginaDiez from './PaginasDx/GetPaginaDiez.jsx';
import GetPaginaDiecinueveM from './PaginasDx/GetPaginaDiecinueveM.jsx';
import GetPaginaVeinteM from './PaginasDx/GetPaginaVeinteM.jsx';
import GetPaginaTrece from './PaginasDx/GetPaginaTrece.jsx';
import { Card } from 'react-bootstrap';

export default function ReporteDxAnual(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const { id } = useParams();
    const [swalProps, setSwalProps] = useState();
    const [datosReporte, setDatosReporte] = useState(null);
    
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    
    const canvasRef = useRef(null);
    const canvasRefDos = useRef(null);
    const canvasRefTres = useRef(null);
    const canvasRefCuatro = useRef(null);
    const canvasRefCinco = useRef(null);
    const canvasRefSeis = useRef(null);
    const canvasRefSiete = useRef(null);
    const canvasRefOcho = useRef(null);
    const canvasRefNueve = useRef(null);
    const canvasRefDiez = useRef(null);
    const canvasRefOnce = useRef(null);
    const canvasRefDoce = useRef(null);
    const canvasRefTrece = useRef(null);
    const canvasRefCatorce = useRef(null);
    const canvasRefQuince = useRef(null);
    const canvasRefDieciseis = useRef(null);
    const canvasRefDiecisiete = useRef(null);
    const canvasRefDieciocho = useRef(null);
    const canvasRefDiecinueve = useRef(null);
    const canvasRefVeinte = useRef(null);
    const canvasRefVeintiuno = useRef(null);
    const canvasRefVeintidos = useRef(null);

    useEffect(() => {
        // draw initial with provided observation text
      canvasRef.current?.draw({
        title: 'Desplazamiento Forzado',
        subTitle: 'en Medellín',
        TituloObservacion: `Informe periodo | ${datosReporte?.datosPaginaTres?.fechaRangoAnioActual || ''}`,
        observations:
          `El desplazamiento forzado, de acuerdo a la definición que aporta la Ley 387 de 1997, implica el cambio de residencia de una o varias personas o de sus actividades económicas habituales, en contra de su voluntad y condicionadas por la necesidad de preservar vida e integridad ante hechos de conflicto armado, violencia organizada u otras circunstancias conexas. La movilidad puede darse entre municipios o al interior de la misma ciudad; a esta última se le reconoce como desplazamiento forzado intraurbano (DFI).`,
        logoSrc: '/dist/img/logo_login.png'
      });
      canvasRefDos.current?.draw({
        title: 'Contenido',
        content: [
            `Comportamiento Desplazamiento Forzado ${datosReporte?.datosPaginaTres?.fechaRangoAnioActual || ''}`,
            'Características de la población atendida',
            `Desplazamiento Forzado Intraurbano (DFI) ${datosReporte?.datosPaginaTres?.fechaRangoAnioActual || ''}`,
            'Causas del DFI',
            'Características de la población atendida',
        ],
        footerText: '',
        tipoInforme: "Mensual",
        logoSrc: '/dist/img/logo_login.png'
      });
      canvasRefTres.current?.draw({
        title: `Comportamiento Desplazamiento Forzado ${datosReporte?.datosPaginaTres?.fechaRangoAnioActual || ''}`,
        textoUno: '*Estos datos no incluyen los Desplazamientos Forzados Intraurbanos (DFI).',
        tipoReporte: 'mensual',
        content: [
          [
            {title: 'MesAnterior', text: 'Año actual'},
            {title: 'Fecha', text: `${datosReporte?.datosPaginaTres?.fechaRangoAnioActual || ''}`},
            {title: 'Hogar', text: `${datosReporte?.datosPaginaTres?.hogaresUltimoMes || '0'}  hogares`},
            {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaTres?.personasUltimoMes || '0'} personas`},
          ],
          [
            {title: 'Variacion', text: 'Variación'},
            {title: 'ObsVariacion', text: 'Con respecto al año anterior'},
            {title: 'Hogar', text: `${datosReporte?.datosPaginaTres?.variacionMesHogares || '0'} hogares ${datosReporte?.datosPaginaTres?.variacionMesHogares > 0 ? 'mas' : 'menos'}`},
            {title: 'Porcentaje', text: `(${datosReporte?.datosPaginaTres?.porcentajeVariacionMesHogares || '0'}%)`},
          ],
          [
            {title: 'AnioAnterior', text: 'Año anterior'},
            {title: 'Fecha', text: `${datosReporte?.datosPaginaTres?.fechaRangoAnioAnterior || ''}`},
            {title: 'Hogar', text: `${datosReporte?.datosPaginaTres?.hogaresAnioAnterior || '0'} hogares`},
            {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaTres?.personasAnioAnterior || '0'} personas`},
          ],
        ],
        logoSrc: '/dist/img/logo_login.png',
        cardIcons: [
          '/dist/img/a9214301-4428-4849-9c30-e7f6abf6a789.png',
          '/dist/img/a3d2cf32-2ead-4f47-ae6b-010238833eaf.png',
          '/dist/img/e472b389-7499-40d0-9cf6-2fcd8bf0183c.png',
          '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
          '/dist/img/1b8c4f8e-7f0a-477e-aaa1-a5c024eccf9a.png',
          '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
        ]
      });
      canvasRefCuatro.current?.draw({
        leftSide: {
            title: datosReporte?.datosPaginaCuatro?.leftSide?.title || '',
            subTitle: datosReporte?.datosPaginaCuatro?.leftSide?.subTitle || '',
            texto: datosReporte?.datosPaginaCuatro?.leftSide?.texto || '',
            textoGrafico: datosReporte?.datosPaginaCuatro?.leftSide?.textoGrafico || '',
            datos: datosReporte?.datosPaginaCuatro?.leftSide?.datos || []
        },
        rightSide: {
            title: datosReporte?.datosPaginaCuatro?.rightSide?.title || '',
            subTitle: datosReporte?.datosPaginaCuatro?.rightSide?.subTitle || '',
            texto: datosReporte?.datosPaginaCuatro?.rightSide?.texto || '',
            textoGrafico: datosReporte?.datosPaginaCuatro?.rightSide?.textoGrafico || '',
            datos: datosReporte?.datosPaginaCuatro?.rightSide?.datos || []
        },
        logoSrc:"/dist/img/logo_login.png"
      });
      canvasRefCinco.current?.draw({
        leftSide : {
            title: datosReporte?.datosPaginaCinco?.leftSide?.title || '',
            subTitle: datosReporte?.datosPaginaCinco?.leftSide?.subTitle || '',
            texto: datosReporte?.datosPaginaCinco?.leftSide?.texto || '',
            textoGrafico: datosReporte?.datosPaginaCinco?.leftSide?.textoGrafico || '',
            datos: datosReporte?.datosPaginaCinco?.leftSide?.datos || []
        },
        rightSide :{
            title: datosReporte?.datosPaginaCinco?.rightSide?.title || '',
            subTitle: datosReporte?.datosPaginaCinco?.rightSide?.subTitle || '',
            texto: datosReporte?.datosPaginaCinco?.rightSide?.texto || '',
            textoGrafico: datosReporte?.datosPaginaCinco?.rightSide?.textoGrafico || '',
            datos: datosReporte?.datosPaginaCinco?.rightSide?.datos || []
        },
        logoSrc:"/dist/img/logo_login.png"
      });
      canvasRefSeis.current?.draw({
        title: datosReporte?.datosPaginaSeis?.title ?? '',
        subTitle: datosReporte?.datosPaginaSeis?.subTitle ?? '',
        graficaUnoData: datosReporte?.datosPaginaSeis?.graficaUnoData ?? [],
        graficaDosData: datosReporte?.datosPaginaSeis?.graficaDosData ?? [],
        textoUno: datosReporte?.datosPaginaSeis?.textoUno ?? '',
        textoDos: datosReporte?.datosPaginaSeis?.textoDos ?? '',
        footerText: datosReporte?.datosPaginaSeis?.footerText ?? '',
        textoRight: datosReporte?.datosPaginaSeis?.textoRight ?? '',
        logoSrc:"/dist/img/logo_login.png",
      });
      canvasRefSiete.current?.draw({
        title: datosReporte?.datosPaginaSiete?.title ?? '',
        subTitle: datosReporte?.datosPaginaSiete?.subTitle ?? '',
        graficaUnoData: datosReporte?.datosPaginaSiete?.graficaUnoData ?? [],
        graficaDosData: datosReporte?.datosPaginaSiete?.graficaDosData ?? [],
        graficaTresData: datosReporte?.datosPaginaSiete?.graficaTresData ?? [],
        textoGraficoUno: datosReporte?.datosPaginaSiete?.textoGraficoUno ?? '',
        textoGraficoDos: datosReporte?.datosPaginaSiete?.textoGraficoDos ?? '',
        textoGraficoTres: datosReporte?.datosPaginaSiete?.textoGraficoTres ?? '',
        textoCualitativo: [
            datosReporte?.datosPaginaSiete?.textoCualitativo ?? '',
            datosReporte?.datosPaginaSiete?.textoCualitativoUno ?? '',
            datosReporte?.datosPaginaSiete?.textoCualitativoDos ?? '',
            datosReporte?.datosPaginaSiete?.textoCualitativoTres ?? '',
        ],
        logoSrc:"/dist/img/logo_login.png",
        });
        canvasRefOcho.current?.draw({
                title: datosReporte?.datosPaginaOcho?.title ?? '',
                subTitle: datosReporte?.datosPaginaOcho?.subTitle ?? '',
                graficaUnoData: datosReporte?.datosPaginaOcho?.graficaUnoData ?? [],
                textoGraficoUno: datosReporte?.datosPaginaOcho?.textoGraficoUno ?? '',
                textoCualitativo: [
                    datosReporte?.datosPaginaOcho?.textoCualitativo ?? '',
                ],
                logoSrc:"/dist/img/logo_login.png",
        })
        canvasRefNueve.current?.draw({
            title: datosReporte?.datosPaginaNueve?.title ?? '',
            titleSquareText: "1.8",
            subTitle: datosReporte?.datosPaginaNueve?.subTitle ?? '',
            texto: datosReporte?.datosPaginaNueve?.texto ?? '',
            recomendaciones: datosReporte?.datosPaginaNueve?.recomendaciones ?? '',
            logoSrc:"/dist/img/logo_login.png",
        });
        canvasRefDiez.current?.draw({
            title: datosReporte?.datosPaginaDiez?.title ?? '',
            titleSquareText: "1.9",
            subTitle: datosReporte?.datosPaginaDiez?.subTitle ?? '',
            texto: datosReporte?.datosPaginaDiez?.texto ?? '',
            recomendaciones: datosReporte?.datosPaginaDiez?.recomendaciones ?? '',
            logoSrc:"/dist/img/logo_login.png",
        });
        canvasRefOnce.current?.draw({
            title: 'Desplazamiento forzado Intraurbano',
            content: [
            [
                {title: 'UltimoMes', text: 'Ultimo mes'},
                {title: 'Fecha', text: `${datosReporte?.datosPaginaTres?.fechaReporte || ''}`},
                {title: 'Hogar', text: `${datosReporte?.datosPaginaOnce?.hogaresUltimoMes || ''} hogares`},
                {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaOnce?.personasUltimoMes || ''} personas`},
            ],
            [
                {title: 'AnioActual', text: 'Año actual'},
                {title: 'Fecha', text: `${datosReporte?.datosPaginaTres?.fechaRangoAnioActual || ''}`},
                {title: 'Hogar', text: `${datosReporte?.datosPaginaOnce?.hogaresAnioActual || ''} hogares`},
                {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaOnce?.personasAnioActual || ''} personas`},
            ],
            [
                {title: 'MesAnterior', text: 'Mes anterior'},
                {title: 'Fecha', text: `${datosReporte?.datosPaginaTres?.fechaRangoMesAnterior || ''}`},
                {title: 'Hogar', text: `${datosReporte?.datosPaginaOnce?.hogaresMesAnterior || ''} hogares`},
                {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaOnce?.personasMesAnterior || ''} personas`},
            ],
            [
                {title: 'Variacion', text: 'Variación'},
                {title: 'ObsVariacion', text: 'Con respecto a la mes anterior'},
                {title: 'Hogar', text: `${datosReporte?.datosPaginaOnce?.variacionMesHogares || ''} hogares ${datosReporte?.datosPaginaOnce?.variacionMesHogares < 0 ? 'menos' : 'más'}`},
                {title: 'Porcentaje', text: `(${datosReporte?.datosPaginaOnce?.porcentajeVariacionMesHogares || ''}%)`},
            ],
            [
                {title: 'AnioAnterior', text: 'Año anterior'},
                {title: 'Fecha', text: `${datosReporte?.datosPaginaTres?.fechaRangoAnioAnterior || ''}`},
                {title: 'Hogar', text: `${datosReporte?.datosPaginaOnce?.hogaresAnioAnterior || ''} hogares`},
                {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaOnce?.personasAnioAnterior || ''} personas`},
            ],
            [
                {title: 'Variacion', text: 'Variación'},
                {title: 'ObsVariacion', text: 'Con respecto al año anterior'},
                {title: 'Hogar', text: `${datosReporte?.datosPaginaOnce?.variacionAnioHogares || ''} hogares ${datosReporte?.datosPaginaOnce?.variacionAnioHogares < 0 ? 'menos' : 'más'}`},
                {title: 'Porcentaje', text: `(${datosReporte?.datosPaginaOnce?.porcentajeVariacionAnioHogares || ''}%)`},
            ],
            ],
            logoSrc: '/dist/img/logo_login.png',
            cardIcons: [
            '/dist/img/a9214301-4428-4849-9c30-e7f6abf6a789.png',
            '/dist/img/a3d2cf32-2ead-4f47-ae6b-010238833eaf.png',
            '/dist/img/e472b389-7499-40d0-9cf6-2fcd8bf0183c.png',
            '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
            '/dist/img/1b8c4f8e-7f0a-477e-aaa1-a5c024eccf9a.png',
            '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
            ]
        });
        canvasRefDoce.current?.draw({
                title:"Mapa de desplazamiento forzado intraurbano",
                logoSrc:"/dist/img/logo_login.png",
        })
        canvasRefTrece.current?.draw({
            title: datosReporte?.datosPaginaTrece?.title ?? '',
            graficaUnoData: datosReporte?.datosPaginaTrece?.graficaData ?? [],
            textoUno: datosReporte?.datosPaginaTrece?.textoUno ?? '',
            textoRight: [
                datosReporte?.datosPaginaTrece?.textoRight?.textoUno ?? '',
                datosReporte?.datosPaginaTrece?.textoRight?.textoDos ?? '',
                datosReporte?.datosPaginaTrece?.textoRight?.textoTres ?? '',
                datosReporte?.datosPaginaTrece?.textoRight?.textoCuatro ?? '',
                ],
            logoSrc:"/dist/img/logo_login.png"
        });
        canvasRefCatorce.current?.draw({
            title: datosReporte?.datosPaginaCatorce?.title ?? '',
            subTitle: datosReporte?.datosPaginaCatorce?.subTitle ?? '',
            graficaUnoData: datosReporte?.datosPaginaCatorce?.graficaUnoData ?? [],
            graficaDosData: datosReporte?.datosPaginaCatorce?.graficaDosData ?? [],
            graficaTresData: datosReporte?.datosPaginaCatorce?.graficaTresData ?? [],
            textoUno: datosReporte?.datosPaginaCatorce?.textoUno ?? '',
            textoDos: datosReporte?.datosPaginaCatorce?.textoDos ?? '',
            textoTres: datosReporte?.datosPaginaCatorce?.textoTres ?? '',
            textoRight: [
                datosReporte?.datosPaginaCatorce?.textoRight?.uno ?? '',
                datosReporte?.datosPaginaCatorce?.textoRight?.dos ?? '',
            ],
            logoSrc:"/dist/img/logo_login.png"
        });
        canvasRefQuince.current?.draw({
            title: datosReporte?.datosPaginaQuince?.title ?? '',
            subTitle: datosReporte?.datosPaginaQuince?.subTitle ?? '',
            graficaUnoData: datosReporte?.datosPaginaQuince?.graficaUnoData ?? [],
            graficaDosData: datosReporte?.datosPaginaQuince?.graficaDosData ?? [],
            textoUno: datosReporte?.datosPaginaQuince?.textoUno ?? '',
            textoDos: datosReporte?.datosPaginaQuince?.textoDos ?? '',
            textoRight: [
                datosReporte?.datosPaginaQuince?.textoRight?.uno ?? '',
                datosReporte?.datosPaginaQuince?.textoRight?.dos ?? '',
            ],
            logoSrc:"/dist/img/logo_login.png",
        });
        canvasRefDieciseis.current?.draw({
            title: datosReporte?.datosPaginaDieciseis?.title ?? '',
            subTitle: datosReporte?.datosPaginaDieciseis?.subTitle ?? '',
            graficaUnoData: datosReporte?.datosPaginaDieciseis?.graficaUnoData ?? [],
            textoUno: datosReporte?.datosPaginaDieciseis?.textoUno ?? '',
            textoRight: [
                datosReporte?.datosPaginaDieciseis?.textoRight?.uno ?? '',
            ],
            logoSrc:"/dist/img/logo_login.png",
        });
        canvasRefDiecisiete.current?.draw({
            title: datosReporte?.datosPaginaDiecisiete?.title ?? '',
            subTitle: datosReporte?.datosPaginaDiecisiete?.subTitle ?? '',
            textoUno: datosReporte?.datosPaginaDiecisiete?.textoUno ?? '',
            logoSrc:"/dist/img/logo_login.png",
            tableTitle: datosReporte?.datosPaginaDiecisiete?.tableTitle ?? '',
            tableData: datosReporte?.datosPaginaDiecisiete?.tableData ?? [],
            tipoReporte: "mensual",
        });
        canvasRefDieciocho.current?.draw({
            title: datosReporte?.datosPaginaDieciocho?.title ?? '',
            subTitle: datosReporte?.datosPaginaDieciocho?.subTitle ?? '',
            texto: datosReporte?.datosPaginaDieciocho?.texto ?? '',
            recomendaciones: datosReporte?.datosPaginaDieciocho?.recomendaciones ?? '',
            logoSrc:"/dist/img/logo_login.png",
            bgColor:"#ffffffff",
        });
        canvasRefDiecinueve.current?.draw({
            title: datosReporte?.datosPaginaDiecinueve?.title ?? '',
            subTitle: datosReporte?.datosPaginaDiecinueve?.subTitle ?? '',
            data: datosReporte?.datosPaginaDiecinueve?.data ?? [],
            logoSrc: '/dist/img/logo_login.png'
        });
        canvasRefVeinte.current?.draw({
            title: 'Datos de interés: Atención Vs inclusión de víctimas en Medellín',
            subTitle: 'Corte, 3O de junio de 2024.',
            data: [
                { categoria: 'Personas incluidas (recibidas en medellins) ', valor: 8023, porcentaje: '100%' },
                { categoria: 'Personas no incluidas (recibidas en medellins) ', valor: 1720, porcentaje: '21%' },
                { categoria: 'Total personas atendidas (2023)', valor: 6553, porcentaje: '79%' },
            ],
            texto: [
                'De las 8.273 personas recibidas en Medellín en el último año (2023), provenientes de otros municipios, 1.720 no han sido incluidos por la Unidad Nacional de Atención y Reparación a Víctimas (UARIV) en el Registro Único de Víctimas (RUV), es decir, el 21%.  Mientras que, 6.553 han sido incluidas o reconocidas, lo que equivale al 79%.',
                'El porcentaje de inclusión varía conforme se actualizan los registros del RUV, por lo cual este no se puede tomar como un dato estático.​',
            ],
            logoSrc:'/dist/img/logo_login.png'
        });
        canvasRefVeintiuno.current?.draw({
            title: 'Datos de interés: Atención Vs inclusión de víctimas en Medellín',
            subTitle: 'Corte, 3O de junio de 2024.',
            data: [
                { categoria: 'Personas incluidas (DFI) ', valor: 1444, porcentaje: '100%' },
                { categoria: 'Personas no incluidas (DFI) ', valor: 934, porcentaje: '65%' },
                { categoria: 'Total personas atendidas por DFI (2023)', valor: 510, porcentaje: '35%' },
            ],
            texto: [
                'De las 1.444 personas atendidas por la Alcaldía de Medellín por la ocurrencia de DFI en 2023, 934 no han sido incluidas por la UARIV en el RUV, es decir, el 65%. Mientras que, 510 fueron incluidas, es decir, el 35%.',
                'El porcentaje de inclusión varía conforme se actualizan los registros del RUV, por lo cual este no se puede tomar como un dato estático.​',
            ],
            logoSrc:'/dist/img/logo_login.png'
        });
        canvasRefVeintidos.current?.draw({
            title:"Glosario",
            glosarioData: [
            { termino: 'Hechos victimizantes', definicion: 'hechos de violencia cometidos contra personas, grupos o comunidades ocurridos en el desarrollo del conflicto armado, por cuya materialización se vulneran derechos a la vida, integridad, seguridad y libertad personal; uno de ellos es el desplazamiento forzado.' },
            { termino: 'Desplazamiento forzado', definicion: 'cambio de residencia de una o varias personas o de sus actividades económicas habituales, en contra de su voluntad y condicionadas por la necesidad de preservar su vida e integridad ante hechos de conflicto armado, violencia organizada u otras circunstancias conexas.' },
            { termino: 'Recepción de personas desplazadas en Medellín', definicion: 'aquellas personas que siendo desplazadas por el conflicto armado o circunstancias conexas a este, migran hacia la ciudad de Medellín, por lo cual se constituye en el municipio receptor de dicha población.' },
            { termino: 'Desplazamiento forzado intraurbano', definicion: 'se denomina intraurbano cuando la persona es desplazada de determinado lugar de la ciudad y se asienta en otro sector de la misma ciudad, en este caso, de Medellín.' },
            { termino: 'Advertencias de posibles riesgos', definicion: 'situaciones que indican la posible inminencia o materialización de algún riesgo en la ciudad, asociado a la ocurrencia de hechos victimizantes que afecten a determinados grupos o comunidades, y por tanto requieren de medidas de prevención urgente.' },
            ],
            logoSrc:"/dist/img/logo_login.png",
        });
    }, []);
    
    const exportPDF = async() => {
        try {
            const img1 = canvasRef.current?.getDataUrl?.() ?? null;
            const img2 = canvasRefDos.current?.getDataUrl?.() ?? null;
            const img3 = canvasRefTres.current?.getDataUrl?.() ?? null;
            const img4 = canvasRefCuatro.current?.getDataUrl?.() ?? null;
            const img5 = canvasRefCinco.current?.getDataUrl?.() ?? null;
            const img6 = canvasRefSeis.current?.getDataUrl?.() ?? null;
            const img7 = canvasRefSiete.current?.getDataUrl?.() ?? null;
            const img8 = canvasRefOcho.current?.getDataUrl?.() ?? null;
            const img9 = datosReporte?.datosPaginaNueve?.subTitle ? canvasRefNueve.current?.getDataUrl?.() ?? null : null;
            const img10 =  datosReporte?.datosPaginaDiez?.subTitle ? canvasRefDiez.current?.getDataUrl?.() ?? null : null;
            const img11 = canvasRefOnce.current?.getDataUrl?.() ?? null;
            const img12 = canvasRefDoce.current?.getDataUrl?.() ?? null;
            const img13 = canvasRefTrece.current?.getDataUrl?.() ?? null;
            const img14 = canvasRefCatorce.current?.getDataUrl?.() ?? null;
            const img15 = canvasRefQuince.current?.getDataUrl?.() ?? null;
            const img16 = canvasRefDieciseis.current?.getDataUrl?.() ?? null;
            const img17 = canvasRefDiecisiete.current?.getDataUrl?.() ?? null;
            const img18 = datosReporte?.datosPaginaDieciocho?.subTitle ? canvasRefDieciocho.current?.getDataUrl?.() ?? null : null;
            const img19 = canvasRefDiecinueve.current?.getDataUrl?.() ?? null;
            const img20 = canvasRefVeinte.current?.getDataUrl?.() ?? null;
            const img21 = canvasRefVeintiuno.current?.getDataUrl?.() ?? null;
            const img22 = canvasRefVeintidos.current?.getDataUrl?.() ?? null;

            if (!img1 || !img2 || !img3 || !img4 || !img5 || 
                !img6 || !img7 || !img8 || !img9 || !img10 || 
                !img11 || !img13 || !img14 || 
                !img16 || !img17 || !img18 || !img19 || 
                 !img22) {
                    console.log('No se pudieron generar todas las imágenes para el PDF');
                    return};
            
            const pdf = new jsPDF('landscape', 'mm', 'letter', {compress: true} );
            const margin = 10;
            const pageW = pdf.internal.pageSize.getWidth() - margin * 2;
    
            if (img1) {
                const props1 = pdf.getImageProperties(img1);
                const h1 = (props1.height * pageW) / props1.width;
                pdf.addImage(img1, 'PNG', margin, margin, pageW, h1);
            }
            if (img2) {
                pdf.addPage();
                const props2 = pdf.getImageProperties(img2);
                const h2 = (props2.height * pageW) / props2.width;
                pdf.addImage(img2, 'PNG', margin, margin, pageW, h2);
            }
            if (img3) {
                pdf.addPage();
                const props3 = pdf.getImageProperties(img3);
                const h3 = (props3.height * pageW) / props3.width;
                pdf.addImage(img3, 'PNG', margin, margin, pageW, h3);
            }
            if (img4) {
                pdf.addPage();
                const props4 = pdf.getImageProperties(img4);
                const h4 = (props4.height * pageW) / props4.width;
                pdf.addImage(img4, 'PNG', margin, margin, pageW, h4);
            }
            if (img5) {
                pdf.addPage();
                const props5 = pdf.getImageProperties(img5);
                const h5 = (props5.height * pageW) / props5.width;
                pdf.addImage(img5, 'PNG', margin, margin, pageW, h5);
            }
            if (img6) {
                pdf.addPage();
                const props6 = pdf.getImageProperties(img6);
                const h6 = (props6.height * pageW) / props6.width;
                pdf.addImage(img6, 'PNG', margin, margin, pageW, h6);
            }
            if (img7) {
                pdf.addPage();
                const props7 = pdf.getImageProperties(img7);
                const h7 = (props7.height * pageW) / props7.width;
                pdf.addImage(img7, 'PNG', margin, margin, pageW, h7);
            }
            if (img8) {
                pdf.addPage();
                const props8 = pdf.getImageProperties(img8);
                const h8 = (props8.height * pageW) / props8.width;
                pdf.addImage(img8, 'PNG', margin, margin, pageW, h8);
            }
            if (img9) {
                pdf.addPage();
                const props9 = pdf.getImageProperties(img9);
                const h9 = (props9.height * pageW) / props9.width;
                pdf.addImage(img9, 'PNG', margin, margin, pageW, h9);
            }
            if (img10) {
                pdf.addPage();
                const props10 = pdf.getImageProperties(img10);
                const h10 = (props10.height * pageW) / props10.width;
                pdf.addImage(img10, 'PNG', margin, margin, pageW, h10);
            }
            if (img11) {
                pdf.addPage();
                const props11 = pdf.getImageProperties(img11);
                const h11 = (props11.height * pageW) / props11.width;
                pdf.addImage(img11, 'PNG', margin, margin, pageW, h11);
            }
            /**if (img12) {
                pdf.addPage();
                const props12 = pdf.getImageProperties(img12);
                const h12 = (props12.height * pageW) / props12.width;
                pdf.addImage(img12, 'PNG', margin, margin, pageW, h12);
            }**/
            if (img13) {
                pdf.addPage();
                const props13 = pdf.getImageProperties(img13);
                const h13 = (props13.height * pageW) / props13.width;
                pdf.addImage(img13, 'PNG', margin, margin, pageW, h13);
            }
            if (img14) {
                pdf.addPage();
                const props14 = pdf.getImageProperties(img14);
                const h14 = (props14.height * pageW) / props14.width;
                pdf.addImage(img14, 'PNG', margin, margin, pageW, h14);
            }
            /**if (img15) {
                pdf.addPage();
                const props15 = pdf.getImageProperties(img15);
                const h15 = (props15.height * pageW) / props15.width;
                pdf.addImage(img15, 'PNG', margin, margin, pageW, h15);
            }**/
            if (img16) {
                pdf.addPage();
                const props16 = pdf.getImageProperties(img16);
                const h16 = (props16.height * pageW) / props16.width;
                pdf.addImage(img16, 'PNG', margin, margin, pageW, h16);
            }
            if (img17) {
                pdf.addPage();
                const props17 = pdf.getImageProperties(img17);
                const h17 = (props17.height * pageW) / props17.width;
                pdf.addImage(img17, 'PNG', margin, margin, pageW, h17);
            }
            if (img18) {
                pdf.addPage();
                const props18 = pdf.getImageProperties(img18);
                const h18 = (props18.height * pageW) / props18.width;
                pdf.addImage(img18, 'PNG', margin, margin, pageW, h18);
            }
            if (img19) {
                pdf.addPage();
                const props19 = pdf.getImageProperties(img19);
                const h19 = (props19.height * pageW) / props19.width;
                pdf.addImage(img19, 'PNG', margin, margin, pageW, h19);
            }
            /**if (img20) {
                pdf.addPage();
                const props20 = pdf.getImageProperties(img20);
                const h20 = (props20.height * pageW) / props20.width;
                pdf.addImage(img20, 'PNG', margin, margin, pageW, h20);
            }
            if (img21) {
                pdf.addPage();
                const props21 = pdf.getImageProperties(img21);
                const h21 = (props21.height * pageW) / props21.width;
                pdf.addImage(img21, 'PNG', margin, margin, pageW, h21);
            }**/
            if (img22) {
                pdf.addPage();
                const props22 = pdf.getImageProperties(img22);
                const h22 = (props22.height * pageW) / props22.width;
                pdf.addImage(img22, 'PNG', margin, margin, pageW, h22);
            }
            pdf.save(`reporte_mensual_${(new Date()).toISOString().slice(0,10)}.pdf`);
        } catch (error) {
            console.error(error);
            setSwalProps({ show: true, title: 'Error', text: 'No se pudo generar el PDF.' });
        }
    }

    useEffect(() => {
        async function fetchReporte(id) {
            if (id !== '0') {
                setCargando(true);
                await apiService.get('/diagnostico/reporteanual/obtenerreporte/' + id, token)
                .then((response) => {
                    if (response.status === 200) {
                        setDatosReporte(response.data);
                        setCargando(false);
                    } else {
                        Mensaje('Error', 'No se pudo obtener el reporte solicitado.');
                        setCargando(false);
                    }
                })
                .catch((error) => {
                    Mensaje('Error', 'No se pudo obtener el reporte solicitado.');
                    setCargando(false);
                });
            }
        }
        fetchReporte(id);
    }, [id]);

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Reporte anual</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><NavLink to="/caracterizacion/reportes" > Reportes</NavLink></li>                                <li className="breadcrumb-item active"> Reportes</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                    </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <Card>
                        <Card.Body>
                        <Card.Text as="div">
                            <div style={{ display: 'flex', gap: 8 }}>
                            <button className="btn btn-sm btn-secondary" onClick={exportPDF}>
                                Descargar PDF
                            </button>
                            </div>
                        </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card>
                        {id !== '0' && datosReporte && <Card.Body>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                <div style={{ width: '100%', overflow: 'hidden' }}>
                                    <GetPaginaUno ref={canvasRef}
                                        title="Desplazamiento Forzado"
                                        TituloObservacion={`Informe periodo | ${datosReporte?.datosPaginaTres?.fechaRangoAnioActual || ''}`}
                                        observations={`El desplazamiento forzado, de acuerdo a la definición que aporta la Ley 387 de 1997, implica el cambio de residencia de una o varias personas o de sus actividades económicas habituales, en contra de su voluntad y condicionadas por la necesidad de preservar vida e integridad ante hechos de conflicto armado, violencia organizada u otras circunstancias conexas. La movilidad puede darse entre municipios o al interior de la misma ciudad; a esta última se le reconoce como desplazamiento forzado intraurbano (DFI).`}
                                        logoSrc="/dist/img/logo_login.png"
                                    />
                                    <div style={{ height: 12 }} />
                                    <GetPaginaDos ref={canvasRefDos}
                                        title="Contenido"
                                        content={[
                                            `Comportamiento Desplazamiento Forzado ${datosReporte?.datosPaginaTres?.fechaRangoAnioActual || ''}`,
                                            'Características de la población atendida',
                                            `Desplazamiento Forzado Intraurbano (DFI) ${datosReporte?.datosPaginaTres?.fechaRangoAnioActual || ''}`,
                                            'Causas del DFI',
                                            'Características de la población atendida',
                                        ]}
                                        footerText=''
                                        tipoInforme="Mensual"
                                        logoSrc="/dist/img/logo_login.png"
                                    />
                                    <div style={{ height: 12 }} />
                                    <GetPaginaTres ref={canvasRefTres}
                                        title={`Comportamiento Desplazamiento Forzado ${datosReporte?.datosPaginaTres?.fechaRangoAnioActual || ''}`}
                                        textoUno="*Estos datos no incluyen los Desplazamientos Forzados Intraurbanos (DFI)."
                                        tipoReporte="anual"
                                        content={[
                                            [
                                                {title: 'MesAnterior', text: 'Año actual'},
                                                {title: 'Fecha', text: `${datosReporte?.datosPaginaTres?.fechaRangoAnioActual || ''}`},
                                                {title: 'Hogar', text: `${datosReporte?.datosPaginaTres?.hogaresUltimoMes || '0'}  hogares`},
                                                {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaTres?.personasUltimoMes || ''} personas`},
                                            ],
                                            [
                                                {title: 'Variacion', text: 'Variación'},
                                                {title: 'ObsVariacion', text: 'Con respecto al año anterior'},
                                                {title: 'Hogar', text: `${datosReporte?.datosPaginaTres?.variacionMesHogares || '0'} hogares menos`},
                                                {title: 'Porcentaje', text: `(${datosReporte?.datosPaginaTres?.porcentajeVariacionMesHogares || '0'}%)`},
                                            ],
                                            [
                                                {title: 'AnioAnterior', text: 'Año anterior'},
                                                {title: 'Fecha', text: `${datosReporte?.datosPaginaTres?.fechaRangoAnioAnterior || ''}`},
                                                {title: 'Hogar', text: `${datosReporte?.datosPaginaTres?.hogaresAnioAnterior || '0'} hogares`},
                                                {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaTres?.personasAnioAnterior || '0'} personas`},
                                            ],
                                        ]}
                                        logoSrc="/dist/img/logo_login.png"
                                        cardIcons={[
                                            '/dist/img/a9214301-4428-4849-9c30-e7f6abf6a789.png',
                                            '/dist/img/a3d2cf32-2ead-4f47-ae6b-010238833eaf.png',
                                            '/dist/img/e472b389-7499-40d0-9cf6-2fcd8bf0183c.png',
                                            '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
                                            '/dist/img/1b8c4f8e-7f0a-477e-aaa1-a5c024eccf9a.png',
                                            '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
                                        ]}
                                    />
                                    <div style={{ height: 12 }} />
                                    <GetPaginaCuatroM 
                                        ref={canvasRefCuatro}
                                        leftSide = {{
                                            title: datosReporte?.datosPaginaCuatro?.leftSide?.title || '',
                                            subTitle: datosReporte?.datosPaginaCuatro?.leftSide?.subTitle || '',
                                            texto: datosReporte?.datosPaginaCuatro?.leftSide?.texto || '',
                                            textoGrafico: datosReporte?.datosPaginaCuatro?.leftSide?.textoGrafico || '',
                                            datos: datosReporte?.datosPaginaCuatro?.leftSide?.datos || []
                                        }}
                                        rightSide = {{
                                            title: datosReporte?.datosPaginaCuatro?.rightSide?.title || '',
                                            subTitle: datosReporte?.datosPaginaCuatro?.rightSide?.subTitle || '',
                                            texto: datosReporte?.datosPaginaCuatro?.rightSide?.texto || '',
                                            textoGrafico: datosReporte?.datosPaginaCuatro?.rightSide?.textoGrafico || '',
                                            datos: datosReporte?.datosPaginaCuatro?.rightSide?.datos || []
                                        }}
                                        logoSrc="/dist/img/logo_login.png"
                                    />
                                    <div style={{ height: 12 }} />
                                    <GetPaginaCincoM 
                                        ref={canvasRefCinco}
                                        leftSide = {{
                                            title: datosReporte?.datosPaginaCinco?.leftSide?.title || '',
                                            subTitle: datosReporte?.datosPaginaCinco?.leftSide?.subTitle || '',
                                            texto: datosReporte?.datosPaginaCinco?.leftSide?.texto || '',
                                            textoGrafico: datosReporte?.datosPaginaCinco?.leftSide?.textoGrafico || '',
                                            datos: datosReporte?.datosPaginaCinco?.leftSide?.datos || []
                                        }}
                                        rightSide = {{
                                            title: datosReporte?.datosPaginaCinco?.rightSide?.title || '',
                                            subTitle: datosReporte?.datosPaginaCinco?.rightSide?.subTitle || '',
                                            texto: datosReporte?.datosPaginaCinco?.rightSide?.texto || '',
                                            textoGrafico: datosReporte?.datosPaginaCinco?.rightSide?.textoGrafico || '',
                                            datos: datosReporte?.datosPaginaCinco?.rightSide?.datos || []
                                        }}
                                        logoSrc="/dist/img/logo_login.png"
                                    />
                                    <div style={{ height: 12 }} />
                                    <GetPaginaSeisM
                                        ref={canvasRefSeis}
                                        title= {datosReporte?.datosPaginaSeis?.title ?? ''}
                                        subTitle= {datosReporte?.datosPaginaSeis?.subTitle ?? ''}
                                        graficaUnoData={datosReporte?.datosPaginaSeis?.graficaUnoData ?? []}
                                        graficaDosData={datosReporte?.datosPaginaSeis?.graficaDosData ?? []}
                                        textoUno= {datosReporte?.datosPaginaSeis?.textoUno ?? ''}
                                        textoDos= {datosReporte?.datosPaginaSeis?.textoDos ?? ''}
                                        footerText= {datosReporte?.datosPaginaSeis?.footerText ?? ''}
                                        textoRight= {datosReporte?.datosPaginaSeis?.textoRight ?? ''}
                                        logoSrc="/dist/img/logo_login.png"
                                    />
                                    <div style={{ height: 12 }} />
                                    <GetPaginaSieteM
                                        ref={canvasRefSiete}
                                        title= {datosReporte?.datosPaginaSiete?.title ?? ''}
                                        subTitle= {datosReporte?.datosPaginaSiete?.subTitle ?? ''}
                                        graficaUnoData={datosReporte?.datosPaginaSiete?.graficaUnoData ?? []}
                                        graficaDosData={datosReporte?.datosPaginaSiete?.graficaDosData ?? []}
                                        graficaTresData={datosReporte?.datosPaginaSiete?.graficaTresData ?? []}
                                        textoGraficoUno= {datosReporte?.datosPaginaSiete?.textoGraficoUno ?? ''}
                                        textoGraficoDos= {datosReporte?.datosPaginaSiete?.textoGraficoDos ?? ''}
                                        textoGraficoTres= {datosReporte?.datosPaginaSiete?.textoGraficoTres ?? ''}
                                        textoCualitativo={[
                                            datosReporte?.datosPaginaSiete?.textoCualitativo ?? '',
                                            datosReporte?.datosPaginaSiete?.textoCualitativoDos ?? '',
                                            datosReporte?.datosPaginaSiete?.textoCualitativoTres ?? '',
                                            datosReporte?.datosPaginaSiete?.textoCualitativoCuatro ?? '',
                                        ]}
                                        logoSrc="/dist/img/logo_login.png"
                                    />
                                    <div style={{ height: 12 }} />
                                    <GetPaginaOchoM
                                        ref={canvasRefOcho}
                                        title= {datosReporte?.datosPaginaOcho?.title ?? ''}
                                        subTitle= {datosReporte?.datosPaginaOcho?.subTitle ?? ''}
                                        graficaUnoData={datosReporte?.datosPaginaOcho?.graficaUnoData ?? []}
                                        textoGraficoUno={datosReporte?.datosPaginaOcho?.textoGraficoUno ?? ''}
                                        textoCualitativo={[datosReporte?.datosPaginaOcho?.textoCualitativo ?? '']}
                                        logoSrc="/dist/img/logo_login.png"
                                    />
                                    <div style={{ height: 12 }} />
                                    {datosReporte?.datosPaginaNueve?.subTitle && <GetPaginaNueveM
                                        ref={canvasRefNueve}
                                        titleSquareText="1.8"
                                        title= {datosReporte?.datosPaginaNueve?.title ?? ''}
                                        subTitle= {datosReporte?.datosPaginaNueve?.subTitle ?? ''}
                                        texto={datosReporte?.datosPaginaNueve?.texto ?? ''}
                                        recomendaciones={datosReporte?.datosPaginaNueve?.recomendaciones ?? ''}
                                        logoSrc="/dist/img/logo_login.png"
                                        />}
                                    <div style={{ height: 12 }} />
                                    {datosReporte?.datosPaginaDiez?.subTitle && <GetPaginaNueveM
                                        ref={canvasRefDiez}
                                        titleSquareText="1.9"
                                        title= {datosReporte?.datosPaginaDiez?.title ?? ''}
                                        subTitle= {datosReporte?.datosPaginaDiez?.subTitle ?? ''}
                                        texto={datosReporte?.datosPaginaDiez?.texto ?? ''}
                                        recomendaciones={datosReporte?.datosPaginaDiez?.recomendaciones ?? ''}
                                        logoSrc="/dist/img/logo_login.png"
                                    />}
                                    <div style={{ height: 12 }} />
                                    <GetPaginaSiete
                                        ref={canvasRefOnce}
                                        title="Desplazamiento Forzado Intraurbano"
                                        content={[
                                        [
                                            {title: 'UltimoMes', text: 'Último mes'},
                                            {title: 'Fecha', text: `${datosReporte?.datosPaginaTres?.fechaReporte || ''}`},
                                            {title: 'Hogar', text: `${datosReporte?.datosPaginaOnce?.hogaresUltimoMes || ''} hogares`},
                                            {title: 'Personas', text: `${datosReporte?.datosPaginaOnce?.personasUltimoMes || ''} personas`},
                                        ],
                                        [
                                            {title: 'AnioActual', text: 'Año actual'},
                                            {title: 'Fecha', text: `${datosReporte?.datosPaginaTres?.fechaRangoAnioActual || ''}`},
                                            {title: 'Hogar', text: `${datosReporte?.datosPaginaOnce?.hogaresAnioActual || ''} hogares`},
                                            {title: 'Personas', text: `${datosReporte?.datosPaginaOnce?.personasAnioActual || ''} personas`},
                                        ],
                                        [
                                            {title: 'MesAnterior', text: 'Mes anterior'},
                                            {title: 'Fecha', text: `${datosReporte?.datosPaginaTres?.fechaAnteriorReporte || ''}`},
                                            {title: 'Hogar', text: `${datosReporte?.datosPaginaOnce?.hogaresMesAnterior || ''} hogares`},
                                            {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaOnce?.personasMesAnterior || ''} personas`},
                                        ],
                                        [
                                            {title: 'Variacion', text: 'Variación'},
                                            {title: 'ObsVariacion', text: 'Con respecto a la semana anterior'},
                                            {title: 'Hogar', text: `${datosReporte?.datosPaginaOnce?.variacionMesHogares || ''} hogares ${datosReporte?.datosPaginaOnce?.variacionMesHogares < 0 ? 'menos' : 'más'}`},
                                            {title: 'Porcentaje', text: `(${datosReporte?.datosPaginaOnce?.porcentajeVariacionMesHogares || ''}%)`},
                                        ],
                                        [
                                            {title: 'AnioAnterior', text: 'Año anterior'},
                                            {title: 'Fecha', text: `${datosReporte?.datosPaginaTres?.fechaRangoAnioAnterior || ''}`},
                                            {title: 'Hogar', text: `${datosReporte?.datosPaginaOnce?.hogaresAnioAnterior || ''} hogares`},
                                            {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaOnce?.personasAnioAnterior || ''} personas`},
                                        ],
                                        [
                                            {title: 'Variacion', text: 'Variación'},
                                            {title: 'ObsVariacion', text: 'Con respecto al año anterior'},
                                            {title: 'Hogar', text: `${datosReporte?.datosPaginaOnce?.variacionAnioHogares || ''} hogares ${datosReporte?.datosPaginaOnce?.variacionAnioHogares < 0 ? 'menos' : 'más'}`},
                                            {title: 'Porcentaje', text: `(${datosReporte?.datosPaginaOnce?.porcentajeVariacionAnioHogares || ''}%)`},
                                        ],
                                        ]}
                                        logoSrc="/dist/img/logo_login.png"
                                        cardIcons={[
                                        '/dist/img/a9214301-4428-4849-9c30-e7f6abf6a789.png',
                                        '/dist/img/a3d2cf32-2ead-4f47-ae6b-010238833eaf.png',
                                        '/dist/img/e472b389-7499-40d0-9cf6-2fcd8bf0183c.png',
                                        '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
                                        '/dist/img/1b8c4f8e-7f0a-477e-aaa1-a5c024eccf9a.png',
                                        '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
                                        ]}
                                    />
                                    <div style={{ height: 24 }} />
                                    {false && <GetPaginaDoceM
                                        ref={canvasRefDoce}
                                        title="Mapa de desplazamiento forzado intraurbano"
                                        mapaSrc="../dist/img/mapaintraurbano.png"
                                        logoSrc="/dist/img/logo_login.png"
                                    />}
                                    <GetPaginaTreceM
                                        ref={canvasRefTrece}
                                        title={datosReporte?.datosPaginaTrece?.title ?? ''}
                                        graficaUnoData={datosReporte?.datosPaginaTrece?.graficaData ?? []}
                                        textoUno={datosReporte?.datosPaginaTrece?.textoUno ?? ''}
                                        textoRight={[
                                            datosReporte?.datosPaginaTrece?.textoRight?.textoUno ?? '',
                                            datosReporte?.datosPaginaTrece?.textoRight?.textoDos ?? '',
                                            datosReporte?.datosPaginaTrece?.textoRight?.textoTres ?? '',
                                            datosReporte?.datosPaginaTrece?.textoRight?.textoCuatro ?? '',
                                            ]}
                                        logoSrc="/dist/img/logo_login.png"
                                    />
                                    <div style={{ height: 20 }}/>
                                    <GetPaginaCatorceM
                                        ref={canvasRefCatorce}
                                        title= {datosReporte?.datosPaginaCatorce?.title ?? ''}
                                        subTitle= {datosReporte?.datosPaginaCatorce?.subTitle ?? ''}
                                        graficaUnoData={datosReporte?.datosPaginaCatorce?.graficaUnoData ?? []}
                                        graficaDosData={datosReporte?.datosPaginaCatorce?.graficaDosData ?? []}
                                        graficaTresData={datosReporte?.datosPaginaCatorce?.graficaTresData ?? []}
                                        textoUno= {datosReporte?.datosPaginaCatorce?.textoUno ?? ''}
                                        textoDos= {datosReporte?.datosPaginaCatorce?.textoDos ?? ''}
                                        textoTres= {datosReporte?.datosPaginaCatorce?.textoTres ?? ''}
                                        textoRight={[
                                            datosReporte?.datosPaginaCatorce?.textoRight?.uno ?? '',
                                            datosReporte?.datosPaginaCatorce?.textoRight?.dos ?? '',
                                        ]}
                                        logoSrc="/dist/img/logo_login.png"
                                    />
                                    <div style={{ height: 20 }}/>
                                    {false &&<GetPaginaQuinceM
                                        ref={canvasRefQuince}
                                        title= {datosReporte?.datosPaginaQuince?.title ?? ''}
                                        subTitle= {datosReporte?.datosPaginaQuince?.subTitle ?? ''}
                                        graficaUnoData={datosReporte?.datosPaginaQuince?.graficaUnoData ?? []}
                                        graficaDosData={datosReporte?.datosPaginaQuince?.graficaDosData ?? []}
                                        textoUno= {datosReporte?.datosPaginaQuince?.textoUno ?? ''}
                                        textoDos= {datosReporte?.datosPaginaQuince?.textoDos ?? ''}
                                        textoRight={[
                                            datosReporte?.datosPaginaQuince?.textoRight?.uno ?? '',
                                            datosReporte?.datosPaginaQuince?.textoRight?.dos ?? '',
                                        ]}
                                        logoSrc="/dist/img/logo_login.png"
                                    />}
                                    <div style={{ height: 12 }} />
                                    <GetPaginaDieciseisM
                                        ref={canvasRefDieciseis}
                                        title= {datosReporte?.datosPaginaDieciseis?.title ?? ''}
                                        subTitle= {datosReporte?.datosPaginaDieciseis?.subTitle ?? ''}
                                        graficaUnoData={datosReporte?.datosPaginaDieciseis?.graficaUnoData ?? []}
                                        textoUno= {datosReporte?.datosPaginaDieciseis?.textoUno ?? ''}
                                        textoRight={[
                                            datosReporte?.datosPaginaDieciseis?.textoRight?.uno ?? '',
                                        ]}
                                        logoSrc="/dist/img/logo_login.png"
                                    />
                                    <div style={{ height: 12 }} />
                                    <GetPaginaDiez
                                        ref={canvasRefDiecisiete}
                                        tipoReporte="mensual"
                                        title= {datosReporte?.datosPaginaDiecisiete?.title ?? ''}
                                        subTitle= {datosReporte?.datosPaginaDiecisiete?.subTitle ?? ''}
                                        textoUno= {datosReporte?.datosPaginaDiecisiete?.textoUno ?? ''}
                                        logoSrc="/dist/img/logo_login.png"
                                        tableTitle= {datosReporte?.datosPaginaDiecisiete?.tableTitle ?? ''}
                                        tableData={datosReporte?.datosPaginaDiecisiete?.tableData ?? []}
                                    />
                                    <div style={{ height: 12 }} />
                                    {datosReporte?.datosPaginaDieciocho?.subTitle && <GetPaginaNueveM
                                        ref={canvasRefDieciocho}
                                        title= {datosReporte?.datosPaginaDieciocho?.title ?? ''}
                                        titleSquareText="2.5"
                                        subTitle= {datosReporte?.datosPaginaDieciocho?.subTitle ?? ''}
                                        texto= {datosReporte?.datosPaginaDieciocho?.texto ?? ''}
                                        recomendaciones= {datosReporte?.datosPaginaDieciocho?.recomendaciones ?? ''}
                                        logoSrc="/dist/img/logo_login.png"
                                        bgColor="#ffffffff"
                                    />}
                                    <div style={{ height: 12 }} />
                                    <GetPaginaDiecinueveM
                                        ref={canvasRefDiecinueve}
                                        title= {datosReporte?.datosPaginaDiecinueve?.title ?? ''}
                                        subTitle= {datosReporte?.datosPaginaDiecinueve?.subTitle ?? ''}
                                        data={datosReporte?.datosPaginaDiecinueve?.data ?? []}
                                        logoSrc="/dist/img/logo_login.png"
                                    />
                                    <div style={{ height: 12 }} />
                                    {false && <GetPaginaVeinteM
                                        ref={canvasRefVeinte}
                                        title='Datos de interés: Atención Vs inclusión de víctimas en Medellín'
                                        subTitle='Corte, 3O de junio de 2024.'
                                        data={[ 
                                            { categoria: 'Personas incluidas (recibidas en medellins) ', valor: 8023, porcentaje: '100%' },
                                            { categoria: 'Personas no incluidas (recibidas en medellins) ', valor: 1720, porcentaje: '21%' },
                                            { categoria: 'Total personas atendidas (2023)', valor: 6553, porcentaje: '79%' },
                                        ]}
                                        texto={[
                                            'De las 8.273 personas recibidas en Medellín en el último año (2023), provenientes de otros municipios, 1.720 no han sido incluidos por la Unidad Nacional de Atención y Reparación a Víctimas (UARIV) en el Registro Único de Víctimas (RUV), es decir, el 21%.  Mientras que, 6.553 han sido incluidas o reconocidas, lo que equivale al 79%.',
                                            'El porcentaje de inclusión varía conforme se actualizan los registros del RUV, por lo cual este no se puede tomar como un dato estático.​',
                                        ]}
                                        logoSrc='/dist/img/logo_login.png'
                                    />}
                                    <div style={{ height: 12 }} />
                                    {false && <GetPaginaVeinteM
                                        ref={canvasRefVeintiuno}
                                        title='Datos de interés: Atención Vs inclusión de víctimas en Medellín'
                                        subTitle='Corte, 3O de junio de 2024.'
                                        data={[
                                            { categoria: 'Personas incluidas (DFI) ', valor: 1444, porcentaje: '100%' },
                                            { categoria: 'Personas no incluidas (DFI) ', valor: 934, porcentaje: '65%' },
                                            { categoria: 'Total personas atendidas por DFI (2023)', valor: 510, porcentaje: '35%' },
                                        ]}
                                        texto={[
                                            'De las 1.444 personas atendidas por la Alcaldía de Medellín por la ocurrencia de DFI en 2023, 934 no han sido incluidas por la UARIV en el RUV, es decir, el 65%. Mientras que, 510 fueron incluidas, es decir, el 35%.',
                                            'El porcentaje de inclusión varía conforme se actualizan los registros del RUV, por lo cual este no se puede tomar como un dato estático.​',
                                        ]}
                                        logoSrc='/dist/img/logo_login.png'
                                    />}
                                    <div style={{ height: 12 }} />
                                    <GetPaginaTrece
                                        ref={canvasRefVeintidos}
                                        title="Glosario"
                                        glosarioData={[
                                        { termino: 'Hechos victimizantes', definicion: 'hechos de violencia cometidos contra personas, grupos o comunidades ocurridos en el desarrollo del conflicto armado, por cuya materialización se vulneran derechos a la vida, integridad, seguridad y libertad personal; uno de ellos es el desplazamiento forzado.' },
                                        { termino: 'Desplazamiento forzado', definicion: 'cambio de residencia de una o varias personas o de sus actividades económicas habituales, en contra de su voluntad y condicionadas por la necesidad de preservar su vida e integridad ante hechos de conflicto armado, violencia organizada u otras circunstancias conexas.' },
                                        { termino: 'Recepción de personas desplazadas en Medellín', definicion: 'aquellas personas que siendo desplazadas por el conflicto armado o circunstancias conexas a este, migran hacia la ciudad de Medellín, por lo cual se constituye en el municipio receptor de dicha población.' },
                                        { termino: 'Desplazamiento forzado intraurbano', definicion: 'se denomina intraurbano cuando la persona es desplazada de determinado lugar de la ciudad y se asienta en otro sector de la misma ciudad, en este caso, de Medellín.' },
                                        { termino: 'Advertencias de posibles riesgos', definicion: 'situaciones que indican la posible inminencia o materialización de algún riesgo en la ciudad, asociado a la ocurrencia de hechos victimizantes que afecten a determinados grupos o comunidades, y por tanto requieren de medidas de prevención urgente.' },
                                        ]}
                                        logoSrc="/dist/img/logo_login.png"
                                    />
                                </div>
                            </div>
                        </Card.Body>}
                    </Card>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}